import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { galleryImages } from '@/mocks/gallery';

export default function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [filter, setFilter] = useState('All');
  const categories = ['All', ...Array.from(new Set(galleryImages.map((g) => g.category)))];
  const filtered =
    filter === 'All' ? galleryImages : galleryImages.filter((g) => g.category === filter);

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
            <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
              Visual Journey
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 mb-4">
              Gallery
            </h1>
            <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
              A collection of moments from Ghalib Chai — our brews, our food,
              our space, and the people who make it special.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex flex-wrap items-center justify-center gap-2 mb-8 md:mb-10">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                    filter === cat
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
              {filtered.map((image, index) => (
                <button
                  key={image.id}
                  onClick={() => setSelectedImage(image.src)}
                  className={`relative overflow-hidden rounded-lg group cursor-pointer ${
                    index === 0 && filtered.length > 4
                      ? 'col-span-2 row-span-2 aspect-square md:aspect-auto'
                      : 'aspect-square'
                  }`}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/30 transition-colors duration-300 flex items-end p-4">
                    <span className="text-background-50 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {image.category}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>

      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] bg-foreground-950/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-background-50 hover:text-accent-400 transition-colors z-10"
            onClick={() => setSelectedImage(null)}
            aria-label="Close gallery"
          >
            <i className="ri-close-line text-3xl" />
          </button>
          <img
            src={selectedImage}
            alt="Gallery preview"
            className="max-w-full max-h-[85vh] rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </>
  );
}